import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { PackingParcelDto, PackingParcelStatus } from '@/types/PackingParcel';

const ENDPOINT = `${APIConfiguration.carrier}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/packing`;

interface GetPackingBySellerByStatusQueryArgs {
  sellerId: string;
  status: PackingParcelStatus;
}

async function getPackingBySellerByStatusQuery({
  sellerId,
  status,
}: GetPackingBySellerByStatusQueryArgs): Promise<
  BackResponse<PackingParcelDto[]> | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    const urlWithParams = buildUrl(url, { Status: status });

    const response = await apiCall<BackResponse<PackingParcelDto[]>>(
      urlWithParams,
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getPackingBySellerByStatusQuery;
